/**
 * WFW-013 — UpCart bridge: disable theme drawer, header badge sync, open UpCart drawer.
 */
(function () {
  if (window.__WYDE_UPCART_BRIDGE__) return;
  window.__WYDE_UPCART_BRIDGE__ = true;

  var PAUSE_MS = 350;
  var pauseTimer = null;
  var hostCache = null;
  var activeFlagTimer = null;
  var suppressBurstTimer = null;

  document.documentElement.setAttribute('data-wyde-theme-cart-disabled', '1');

  function setFigmaPause(ms) {
    window.__WYDE_UPCART_FIGMA_PAUSE__ = true;
    if (pauseTimer) clearTimeout(pauseTimer);
    pauseTimer = setTimeout(function () {
      pauseTimer = null;
      window.__WYDE_UPCART_FIGMA_PAUSE__ = false;
      try {
        document.dispatchEvent(new CustomEvent('wyde:upcart:figma-resume'));
      } catch (_) {}
    }, ms != null ? ms : PAUSE_MS);
  }

  function notifyCartChange() {
    setFigmaPause(PAUSE_MS);
    try {
      document.dispatchEvent(new CustomEvent('wyde:upcart:cart-change', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('wyde:upcart:cart-change'));
    } catch (_) {}
  }

  function getHost() {
    try {
      if (
        hostCache &&
        hostCache.isConnected !== false &&
        hostCache.shadowRoot &&
        document.documentElement.contains(hostCache)
      ) {
        return hostCache;
      }
    } catch (_) {}
    hostCache = null;

    var ids = ['upCart', 'upcart', 'UpCart', 'UPCART'];
    for (var i = 0; i < ids.length; i++) {
      try {
        var el = document.getElementById(ids[i]);
        if (el && el.shadowRoot) {
          hostCache = el;
          return el;
        }
      } catch (_) {}
    }

    if (!document.body) return null;
    var walk = document.body.getElementsByTagName('*');
    for (var k = 0; k < walk.length; k++) {
      try {
        var cand = walk[k];
        var sr = cand && cand.shadowRoot ? cand.shadowRoot : null;
        if (!sr) continue;
        if (sr.querySelector('[id*="UpcartPopup"], [id*="CartPopup"], [data-upcart]')) {
          hostCache = cand;
          return cand;
        }
      } catch (_) {}
    }
    return null;
  }

  function getPopup() {
    var host = getHost();
    if (!host || !host.shadowRoot) return null;
    return (
      host.shadowRoot.getElementById('UpcartPopup') ||
      host.shadowRoot.getElementById('CartPopup') ||
      host.shadowRoot.querySelector('[id*="UpcartPopup"], [id*="CartPopup"]')
    );
  }

  function isDrawerOpen() {
    var popup = getPopup();
    if (!popup) return false;
    if (popup.classList.contains('styles_active__')) return true;
    if (popup.getAttribute('aria-hidden') === 'false') return true;
    try {
      var st = window.getComputedStyle(popup);
      return st.display !== 'none' && st.visibility !== 'hidden' && st.opacity !== '0';
    } catch (_) {
      return false;
    }
  }

  function isActive() {
    return !!getHost();
  }

  function setUpcartActiveFlag() {
    if (isActive()) {
      document.documentElement.setAttribute('data-wyde-upcart-active', '1');
    } else {
      document.documentElement.removeAttribute('data-wyde-upcart-active');
    }
  }

  function scheduleActiveFlagCheck() {
    if (activeFlagTimer) clearTimeout(activeFlagTimer);
    activeFlagTimer = setTimeout(function () {
      activeFlagTimer = null;
      setUpcartActiveFlag();
    }, 120);
  }

  function openCart() {
    if (typeof window.upcartOpenCart === 'function') {
      try {
        window.upcartOpenCart();
        return true;
      } catch (_) {}
    }
    if (window.UpCart && typeof window.UpCart.open === 'function') {
      try {
        window.UpCart.open();
        return true;
      } catch (_) {}
    }
    return false;
  }

  function disableThemeCartDrawerEl(d) {
    if (!d) return;
    try {
      if (typeof d.close === 'function') d.close();
    } catch (_) {}
    d.classList.remove('is-opened');
    d.removeAttribute('open');
    d.setAttribute('aria-hidden', 'true');
    d.style.setProperty('display', 'none', 'important');
    d.style.setProperty('visibility', 'hidden', 'important');
    d.style.setProperty('pointer-events', 'none', 'important');
  }

  function closeThemeCartDrawer() {
    document.querySelectorAll('#CartDrawer, cart-drawer').forEach(disableThemeCartDrawerEl);
  }

  function suppressThemeCartDrawer() {
    closeThemeCartDrawer();
    var backdrop = document.querySelector('[data-sidebar-backdrop], .sidebar-backdrop, [data-header-dropdown-backdrop]');
    if (backdrop) {
      backdrop.classList.remove('is-opened', 'is-visible', 'active');
      backdrop.setAttribute('aria-hidden', 'true');
    }
    document.documentElement.classList.remove('sidebar-open', 'drawer-open', 'cart-drawer-open');
    document.body.classList.remove('sidebar-open', 'drawer-open', 'cart-drawer-open');
  }

  function canOpenUpcart() {
    if (typeof window.upcartOpenCart === 'function') return true;
    if (window.UpCart && typeof window.UpCart.open === 'function') return true;
    if (window.__WYDE_UPCART__ && typeof window.__WYDE_UPCART__.openCart === 'function') {
      return true;
    }
    return isActive();
  }

  function getCartFallbackHref(el) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!el || !el.closest) return root + 'cart';
    var link = el.closest('a[href]');
    if (link && link.querySelector('.header__cart-icon')) {
      return link.getAttribute('href') || root + 'cart';
    }
    return root + 'cart';
  }

  function isCartDrawerTrigger(el) {
    if (!el || !el.closest) return false;
    if (
      el.closest(
        '[data-sidebar-button][data-sidebar-id="CartDrawer"], [data-cart-drawer-toggle], [data-drawer-toggle="cart"], [data-sticky-cart-open], button[name="open-cart"], .js-drawer-open-cart, .header__cart-icon, sticky-cart-button'
      )
    ) {
      return true;
    }
    var cartLink = el.closest('a.header__icon');
    if (cartLink && cartLink.querySelector('.header__cart-icon')) return true;
    var sb = el.closest('sidebar-button');
    return !!(sb && sb.querySelector('[data-sidebar-id="CartDrawer"]'));
  }

  function startSuppressBurst() {
    suppressThemeCartDrawer();
    if (suppressBurstTimer) clearInterval(suppressBurstTimer);
    var ticks = 0;
    suppressBurstTimer = setInterval(function () {
      ticks += 1;
      suppressThemeCartDrawer();
      if (ticks >= 80) {
        clearInterval(suppressBurstTimer);
        suppressBurstTimer = null;
      }
    }, 50);
  }

  function openCartWithRetry(onFail) {
    startSuppressBurst();
    if (openCart()) return;
    var tries = 0;
    var retry = setInterval(function () {
      tries += 1;
      suppressThemeCartDrawer();
      if (openCart()) {
        clearInterval(retry);
        return;
      }
      if (tries >= 40) {
        clearInterval(retry);
        if (typeof onFail === 'function') onFail();
      }
    }, 150);
  }

  var lastCartTriggerMs = 0;

  function handleCartTrigger(e) {
    if (!isCartDrawerTrigger(e.target)) return;

    var fallbackHref = getCartFallbackHref(e.target);
    var cartLink =
      e.target.closest && e.target.closest('a.header__icon') && e.target.closest('a.header__icon').querySelector('.header__cart-icon')
        ? e.target.closest('a.header__icon')
        : null;

    if (cartLink && !canOpenUpcart()) return;

    e.preventDefault();
    e.stopPropagation();

    var now = Date.now();
    if (now - lastCartTriggerMs < 400) return;
    lastCartTriggerMs = now;

    if (!canOpenUpcart()) {
      window.location.href = fallbackHref;
      return;
    }

    openCartWithRetry(function () {
      window.location.href = fallbackHref;
    });
  }

  function interceptThemeCartOpens() {
    document.addEventListener('click', handleCartTrigger, true);
  }

  function patchSidebarButtons() {
    document.querySelectorAll('sidebar-button').forEach(function (sb) {
      if (sb.__wydeUpcartSidebarPatch) return;
      if (!sb.querySelector('[data-sidebar-id="CartDrawer"]')) return;
      sb.__wydeUpcartSidebarPatch = true;
      sb.addEventListener('click', handleCartTrigger, true);
    });
  }

  function patchThemeCartDrawerElement() {
    function patch(el) {
      if (!el) return;
      if (el.__wydeUpcartDrawerPatched) return;
      el.__wydeUpcartDrawerPatched = true;
      disableThemeCartDrawerEl(el);
      if (typeof el.open === 'function') {
        el.open = function () {
          suppressThemeCartDrawer();
          openCartWithRetry();
        };
      }
      if (typeof el.show === 'function') {
        el.show = function () {
          suppressThemeCartDrawer();
          openCartWithRetry();
        };
      }
    }
    document.querySelectorAll('#CartDrawer, cart-drawer').forEach(patch);
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-drawer').then(function () {
        document.querySelectorAll('#CartDrawer, cart-drawer').forEach(patch);
      }).catch(function () {});
    }
  }

  function hideUpcartDuplicateCounters() {
    var selectors = [
      '[data-upcart-cart-count]',
      '.upcart-public-cart-count',
      '.upcart-cart-count',
      '.upcart-header-cart-count',
      '[class*="upcart"][class*="cart-count"]:not(cart-count):not(.cart-count)'
    ];
    selectors.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (node) {
          if (node.closest('cart-count, #CartCount, .header__cart-icon')) return;
          node.style.setProperty('display', 'none', 'important');
        });
      } catch (_) {}
    });
  }

  function renderBadge(el, count) {
    if (!el) return;
    if (!count || count <= 0) {
      el.innerHTML = '';
      return;
    }
    el.innerHTML =
      '<div class="cart-count' +
      (count > 9 ? ' cart-count--ellipse' : '') +
      '"><span aria-hidden="true">' +
      count +
      '</span></div>';
  }

  function normalizeBadge(el) {
    if (!el) return;
    var bubble = el.querySelector('.cart-count');
    if (bubble) {
      var n = parseInt(String(bubble.textContent || '').trim(), 10);
      if (isNaN(n) || n <= 0) {
        el.innerHTML = '';
      }
      return;
    }
    var text = String(el.textContent || '').trim();
    if (text === '' || text === '0') {
      el.innerHTML = '';
      return;
    }
    if (/^\d+$/.test(text)) {
      renderBadge(el, parseInt(text, 10));
    }
  }

  function scrubZeroBadges() {
    document.querySelectorAll('cart-count, #CartCount').forEach(normalizeBadge);
    hideUpcartDuplicateCounters();
  }

  function syncBadgesFromCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var originFetch =
      typeof window.__WYDE_ORIGIN_FETCH__ === 'function'
        ? window.__WYDE_ORIGIN_FETCH__
        : window.fetch.bind(window);
    originFetch(root + 'cart.js?t=' + Date.now(), {
      method: 'GET',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('cart-count, #CartCount').forEach(function (el) {
          renderBadge(el, cart && cart.item_count != null ? cart.item_count : 0);
        });
        hideUpcartDuplicateCounters();
      })
      .catch(function () {
        scrubZeroBadges();
      });
  }

  window.__WYDE_UPCART__ = {
    isActive: isActive,
    isDrawerOpen: isDrawerOpen,
    openCart: openCart,
    notifyCartChange: notifyCartChange,
    scrubZeroBadges: scrubZeroBadges,
    syncBadgesFromCart: syncBadgesFromCart,
    suppressThemeCartDrawer: suppressThemeCartDrawer
  };

  suppressThemeCartDrawer();
  patchThemeCartDrawerElement();
  patchSidebarButtons();
  interceptThemeCartOpens();
  scrubZeroBadges();
  syncBadgesFromCart();
  scheduleActiveFlagCheck();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      suppressThemeCartDrawer();
      patchThemeCartDrawerElement();
      patchSidebarButtons();
      scrubZeroBadges();
      syncBadgesFromCart();
      scheduleActiveFlagCheck();
    });
  }

  window.addEventListener('pageshow', function () {
    suppressThemeCartDrawer();
    patchThemeCartDrawerElement();
    patchSidebarButtons();
    scrubZeroBadges();
    syncBadgesFromCart();
    scheduleActiveFlagCheck();
  });

  window.addEventListener('popstate', suppressThemeCartDrawer);

  document.addEventListener('shopify:section:load', function () {
    suppressThemeCartDrawer();
    patchThemeCartDrawerElement();
    patchSidebarButtons();
    scrubZeroBadges();
    syncBadgesFromCart();
  });

  var badgeObs = new MutationObserver(function () {
    scrubZeroBadges();
  });
  function watchBadges() {
    document.querySelectorAll('cart-count, #CartCount').forEach(function (el) {
      try {
        badgeObs.observe(el, { childList: true, subtree: true, characterData: true });
      } catch (_) {}
    });
  }
  watchBadges();

  var hostObs = new MutationObserver(function () {
    watchBadges();
    scheduleActiveFlagCheck();
    suppressThemeCartDrawer();
    patchThemeCartDrawerElement();
    patchSidebarButtons();
  });
  hostObs.observe(document.documentElement, { childList: true, subtree: true });

  var themeDrawerObs = new MutationObserver(function () {
    var opened = false;
    document.querySelectorAll('#CartDrawer, cart-drawer').forEach(function (d) {
      if (d.classList.contains('is-opened') || d.getAttribute('open') != null) {
        opened = true;
      }
    });
    if (opened) openCartWithRetry();
  });
  themeDrawerObs.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'open'],
    subtree: true
  });
})();
